import {
  Button,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  TextRegular,
  TextSemiBold
} from '@hm/fundamental'
import React from 'react'

import {useTranslation} from '../../../hooks/useTranslation'

type DeleteUserDialogProps = {
  showDeleteUserDialog: boolean
  setShowDeleteUserDialog: (show: boolean) => void
  handleDeleteUser: () => void
}
export const DeleteUserDialog = ({
  setShowDeleteUserDialog,
  showDeleteUserDialog,
  handleDeleteUser
}: DeleteUserDialogProps) => {
  const {t} = useTranslation()

  return (
    <Modal
      open={showDeleteUserDialog}
      onClose={() => setShowDeleteUserDialog(false)}
      data-cy="manage-user-dialog-delete-user"
    >
      <ModalTitle>{t('manageUser.deleteUserDialogTitle')}</ModalTitle>
      <ModalContent>
        <div className="flex flex-col gap-2">
          <TextRegular> {t('manageUser.deleteUserDialogMessage')}</TextRegular>
          <TextSemiBold> {t('manageUser.deleteUserDialogMessageWarning')}</TextSemiBold>
        </div>
      </ModalContent>
      <ModalFooter>
        <Button
          size="large"
          variant="tertiary"
          onClick={() => setShowDeleteUserDialog(false)}
          data-cy="delete-user-dialog-action-cancel"
          type="button"
        >
          {t('manageUser.resetPasswordDialogActionCancel')}
        </Button>
        <Button
          size="large"
          onClick={handleDeleteUser}
          data-cy="button-delete-confirm"
          type="button"
        >
          {t('manageUser.deleteUserDialogActionOk')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
